import { Construction } from "lucide-react";
import { useTranslation } from "react-i18next";
import { AppLayout } from "../components/layout/AppLayout.js";
import { Header } from "../components/layout/Header.js";

export function ComingSoon({ title }: { title: string }) {
  const { t } = useTranslation();
  return (
    <AppLayout>
      <Header title={title} />
      <div className="flex-1 flex flex-col items-center justify-center gap-3 page-enter">
        <Construction size={32} style={{ color: "var(--text-muted)" }} />
        <p className="text-sm" style={{ color: "var(--text-muted)" }}>
          {t("common.comingSoon")}
        </p>
      </div>
    </AppLayout>
  );
}
